<script setup lang="ts">
definePageMeta({
  scrollToTop: true,
});

const route = useRoute();
const routeName = route.params.policy.toString();

const page: { [key: string]: string } = {
  "cookie-policy": "Cookie Policy",
  "privacy-policy": "Privacy Policy",
  "terms-and-conditions": "Terms & Conditions",
  "influencer-program-terms-conditions":
    "Influencer Program Terms & Conditions",
};

useSeoMeta({
  title: page[routeName],
  description: page[routeName],
});
</script>
<template>
  <div class="-mt-10">
    <NuxtLinkLocale
      to="/"
      class="group flex items-center text-neutral-200 hover:text-primary-500 font-bold cursor-pointer mb-4"
      data-test="link-back-to-marketplace">
      <NuxtIcon
        name="mdi:chevron-left"
        class="h-5 w-5 shrink-0 text-neutral-300 group-hover:text-primary-500 mr-1"
        aria-hidden="true" />
      {{ $t("main.pageLegal.backToMarketplace") }}</NuxtLinkLocale
    >
    <LegalCookiePolicy v-if="page[routeName] === 'Cookie Policy'" />
    <LegalTermsAndConditions v-if="page[routeName] === 'Terms & Conditions'" />
    <LegalPrivacyPolicy v-if="page[routeName] === 'Privacy Policy'" />
    <LegalInfluencerPolicy
      v-if="page[routeName] === 'Influencer Program Terms & Conditions'" />
  </div>
</template>
